import config from 'next/config';
import { customSWRResponse } from '../../model/types';
import useSingleCompanySetting from './useSingleCompanySetting';

export default function useCompanyOwnerId(): customSWRResponse<number> {
    const { data, error, isLoading } = useSingleCompanySetting('OWNER_ID', { ...config });

    return {
        data: data?.value ? +data.value : undefined,
        error,
        isLoading
    };
}
